import React from 'react';

/**
 * Hero side panel: a stylised topology of the kind of system I build —
 * clients → gateway → orchestrated services → models and stores.
 * Flow lines animate via CSS (see header.css).
 */

const NODES = [
  { x: 96, y: 16, w: 208, h: 34, label: 'Web · Mobile · CRM', kind: 'edge' },
  { x: 76, y: 90, w: 248, h: 34, label: 'API Gateway · OAuth2 / RBAC', kind: 'gate' },
  { x: 12, y: 164, w: 116, h: 40, label: 'AI Orchestrator', kind: 'ai' },
  { x: 142, y: 164, w: 116, h: 40, label: 'Core Services', kind: 'svc' },
  { x: 272, y: 164, w: 116, h: 40, label: 'Payments', kind: 'svc' },
  { x: 12, y: 250, w: 116, h: 40, label: 'Vector / RAG', kind: 'ai' },
  { x: 142, y: 250, w: 116, h: 40, label: 'PostgreSQL', kind: 'data' },
  { x: 272, y: 250, w: 116, h: 40, label: 'LLM Providers', kind: 'ai' },
];

const EDGES = [
  { d: 'M200 50 L200 90', delay: 0 },
  { d: 'M140 124 L140 150 L70 150 L70 164', delay: 0.25 },
  { d: 'M200 124 L200 164', delay: 0.5 },
  { d: 'M260 124 L260 150 L330 150 L330 164', delay: 0.75 },
  { d: 'M70 204 L70 250', delay: 1 },
  { d: 'M200 204 L200 250', delay: 1.25 },
  { d: 'M330 204 L330 250', delay: 1.5 },
  { d: 'M128 184 L142 184', delay: 1.75 },
  { d: 'M258 184 L272 184', delay: 2 },
];

const SystemDiagram = () => (
  <svg
    className="hero__diagram"
    viewBox="0 0 400 306"
    role="img"
    aria-label="Reference architecture: clients to API gateway, to AI orchestrator, core services and payments, backed by a vector store, PostgreSQL and LLM providers."
  >
    <defs>
      <linearGradient id="diagram-ai" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="rgba(94,234,212,0.20)" />
        <stop offset="100%" stopColor="rgba(129,140,248,0.16)" />
      </linearGradient>
      <linearGradient id="diagram-flow" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#5eead4" />
        <stop offset="100%" stopColor="#818cf8" />
      </linearGradient>
    </defs>

    {EDGES.map((edge) => (
      <g key={edge.d}>
        <path className="hero__edge" d={edge.d} />
        <path className="hero__edge-flow" d={edge.d} style={{ animationDelay: `${edge.delay}s` }} />
      </g>
    ))}

    {NODES.map((node) => (
      <g key={node.label} className={`hero__node hero__node--${node.kind}`}>
        <rect x={node.x} y={node.y} width={node.w} height={node.h} rx="9" />
        <text x={node.x + node.w / 2} y={node.y + node.h / 2 + 3.5} textAnchor="middle">
          {node.label}
        </text>
      </g>
    ))}
  </svg>
);

export default SystemDiagram;
